import { PureComponent } from 'react'
import { FeedUserUidOwnProps, PostUidOwnProps } from 'selectors/feedSelectors'
import FeedUserInfoContainer from 'components/features/socialFeed/FeedUserInfo/FeedUserInfoContainer'
import { MatchingPeergroup } from 'interfaces/feed'


export type FeedPostHeaderStateProps = {
  isOwn: boolean
  isEdited: boolean
  created: string
  matchingPeergroup?: MatchingPeergroup
}

export type FeedPostHeaderOwnProps =
  & FeedUserUidOwnProps
  & PostUidOwnProps

export type FeedPostHeaderDispatchProps = {
}

export type FeedPostHeaderInnerProps =
  & FeedPostHeaderStateProps
  & FeedPostHeaderDispatchProps
  & FeedPostHeaderOwnProps


export type FeedPostHeaderProps =
  & FeedPostHeaderInnerProps


class FeedPostHeader extends PureComponent<FeedPostHeaderProps> {

  render () {
    const {
      postUid,
      userUid,
      created,
      isOwn,
      isEdited,
      matchingPeergroup,
    } = this.props

    return (
      <FeedUserInfoContainer
        postUid={ postUid }
        userUid={ userUid }
        created={ created }
        isEdited={ isEdited }
        mode='post'
        matchingPeergroup={ matchingPeergroup }
        isOwn={ isOwn }
      />
    )
  }

}

export default FeedPostHeader
